// extracted by mini-css-extract-plugin
module.exports = {"fade":"_TbYy","show":"_1HUQN","collapse":"RIIpn","collapsing":"_1HM-b","collapsing-horizontal":"_2RLW0","collapse-only-mobile":"_81Fbx","collapse-only-desktop":"_14eme"};